package one.healthium.life.presentation.navigation.today

import com.arkivanov.decompose.ComponentContext
import one.healthium.tasks.domain.DailyTaskModel

class DefaultTodayComponent(
    componentContext: ComponentContext,
    private val onMealPlanClicked: (String) -> Unit,
    private val onLogFoodClicked: () -> Unit,
    private val onLogWaterClicked: () -> Unit,
    private val onLogWeightClicked: () -> Unit,
    private val onLogSymptomsClicked: () -> Unit,
    private val onDailyTaskClicked: (DailyTaskModel) -> Unit,
) : TodayComponent, ComponentContext by componentContext {
    override fun onLogWeightClicked() {
        onLogWeightClicked.invoke()
    }

    override fun onLogWaterClicked() {
        onLogWaterClicked.invoke()
    }

    override fun onMealPlanClicked(id: String) {
        onMealPlanClicked.invoke(id)
    }

    override fun onDailyTaskClicked(dailyTask: DailyTaskModel) {
        onDailyTaskClicked.invoke(dailyTask)
    }

    override fun onLogFoodClicked() {
        onLogFoodClicked.invoke()
    }

    override fun onLogSymptomsClicked() {
        onLogSymptomsClicked.invoke()
    }
}
